/**
 * Chinese About Translations
 * 关于页翻译模块 - 中文
 * 
 * 包含公司介绍、发展历程、使命价值观、认证专利等翻译
 */

import type { AboutTranslations } from '../../types';

export const zhAbout: AboutTranslations = {
  title: '关于我们',
  subtitle: '通过创新为可持续未来创造舒适。',
  header: {
    title: '关于晶辉',
    subtitle: '通过创新为可持续未来创造舒适。',
  },
  history: {
    title: '发展历程',
    desc: '福建晶辉环境科技有限公司（JH Heatsup）成立于2006年，起初是一个简单的愿景：创造不仅强大而且环保负责的取暖和制冷解决方案。位于繁华的福州高新技术园区，我们已从一个小型研发团队成长为全球制造商。',
    timelineTitle: '红外取暖发展里程碑',
    timelineDesc: '从首批远红外取暖器系列，到智能互联与浴室快速取暖，六个节点见证我们的持续创新。',
    milestones: [
      { year: '2013', title: '开启远红外取暖器生产', desc: '13A 与 13B 系列远红外辐射取暖器成功投入生产。' },
      { year: '2015', title: '产品系列持续扩展', desc: '推出 14A/14B 与 15A/15B 系列远红外辐射取暖器。' },
      { year: '2017', title: '取暖器融入蓝牙功能', desc: '配备蓝牙音箱的 JH13C 系列正式上市。' },
      { year: '2018', title: '拓展更多取暖场景', desc: '踢脚线取暖器上市，并开始生产浴室远红外取暖器。' },
      { year: '2019', title: '迈入 Wi-Fi 智能取暖', desc: '具备 Wi-Fi 功能的 13W 系列智能取暖器正式上市。' },
      { year: '2021', title: '实现浴室五秒快速升温', desc: '成功开发可在五秒内快速升温的玻璃面板浴室取暖器。' },
    ],
  },
  mission: {
    title: '企业使命',
  },
  quality: {
    title: '质量保证',
    desc: '通过ISO9001认证的流程。每台取暖器在出厂前都经过测试。',
  },
  values: {
    title: '核心价值观',
    sustainability: {
      title: '可持续与创新',
      desc: '创新节能技术，降低碳排放，提升取暖效率。',
    },
    quality: {
      title: '品质认证',
      desc: 'ISO9001认证工厂制造，严格测试确保卓越性能。',
    },
    customerFirst: {
      title: '全球信任与合作',
      desc: '深受100+国家800+全球合作伙伴信赖，以客户为中心建立长期合作关系。',
    },
  },
  features: {
    title: '产品特性',
    fast: {
      title: '快速升温',
      desc: '高效红外技术，快速达到舒适温度。',
    },
    energy: {
      title: '节能省电',
      desc: '智能控制，帮助降低取暖成本。',
    },
    healthy: {
      title: '健康舒适',
      desc: '辐射取暖，不干燥空气，更加舒适。',
    },
    safe: {
      title: '安全可靠',
      desc: '多重安全保护，使用更安心。',
    },
  },
  companyProfile: {
    title: '公司概况',
    desc: '福建晶辉环境科技有限公司成立于2006年，总部位于中国福州。是一家知名的以蒸发式冷气机和远红外辐射取暖器为核心技术、核心产品的环境空气温度、湿度以及空气质量解决方案的提供商和服务商，也是一家专注于研究和生产节能环保产品蒸发式冷气机和远红外辐射取暖器中国高新技术企业。',
  },
  services: {
    title: '专业服务',
    desc: '我们拥有专业的技术工程师和经验丰富的销售人员，为您在工业和商业制冷/取暖应用方面提供高质量的服务，如为工厂车间、商场、健身房、咖啡厅、温室、户外场所等各种场所提供高品质的产品和舒适的温度、湿度、新鲜空气的良好解决方案。',
  },
  technology: {
    title: '领先技术',
    desc: '我们将纳米陶瓷涂料应用于远红外辐射取暖器，改变了传统辐射取暖器表面变色和涂料易脱落的问题，使其辐射效率更高、速度更快。我们先进的远红外技术提供快速升温和均匀的热分布，创造温暖舒适的居住环境。',
    nanoCeramic: { title: '纳米陶瓷漆技术', desc: '提升辐射效率，更快升温' },
    farInfrared: { title: '远红外辐射', desc: '均匀散热，舒适宜人' },
  },
  certifications: {
    title: '认证与专利',
    desc: '我们已获得32+项外观、实用新型和发明专利。我们的产品符合CCC、ISO9001:2015、CE、CB、SAA、EMC、SASO等国际安全认证标准，确保质量保证。',
  },
  clients: {
    title: '全球客户',
    desc: '我们的取暖产品已出口到全球100+个国家和地区，深受全球用户信赖。',
    export: '产品出口100+国家和地区',
    agents: '800+国际代理商',
    trusted: '全球用户信赖',
    showcaseTitle: '深受全球合作伙伴信赖',
    showcaseDesc: '在国际展会上，我们与来自世界各地的经销商、项目采购商和行业伙伴面对面交流，深入了解不同市场的取暖需求，展示最新的红外取暖解决方案，并以可靠的产品、稳定的品质和及时的服务建立长期合作关系。',
  },
  manufacturing: {
    title: '制造能力',
    desc: '我们拥有4500平方米的生产车间，150+名技术工程师和技术工人，月产能超过10000台取暖产品。我们有能力按时按质按量完成每一个订单。',
    workshopArea: '车间面积',
    engineersWorkers: '技术工程师和工人',
    monthlyCapacity: '月产能',
    patents: '专利数量',
  },
  ceo: {
    title: '我们的创始人',
    name: '黄雪芳女士',
    role: '创始人',
    desc: '黄雪芳女士是中国最早的远红外取暖器研究者之一。2003年，她与一群热爱制冷技术的合作伙伴共同开发设计了蒸发式产品。2006年，她创立了福建晶辉环境科技有限公司。2011年，她带领研发团队设计了板式远红外辐射加热器，巧妙地将智能控制器、蓝牙音箱和WIFI应用于电暖器，使红外加热器不仅具有单一的取暖功能，更是一种生活方式。每一个设计细节都体现了她将西方美学与东方魅力的融合，赋予产品鲜活的生命力。',
    quote: '"我们致力于通过科技创造一个更绿色、更温暖的世界。"',
  },
  applications: {
    title: '应用场景',
    desc: '我们的远红外取暖器广泛应用于各种场景，为您提供全面的取暖解决方案',
    restaurant: {
      title: '餐馆',
      desc: '',
      icon: 'Utensils',
    },
    livingRoom: {
      title: '客厅',
      desc: '',
      icon: 'Sofa',
    },
    office: {
      title: '办公室',
      desc: '',
      icon: 'Building',
    },
    patio: {
      title: '露台',
      desc: '',
      icon: 'Sun',
    },
    sauna: {
      title: '桑拿房',
      desc: '',
      icon: 'Flame',
    },
    garage: {
      title: '车库',
      desc: '',
      icon: 'Warehouse',
    },
    balcony: {
      title: '健身房',
      desc: '',
      icon: 'Dumbbell',
    },
    entertainment: {
      title: '娱乐室',
      desc: '',
      icon: 'Gamepad2',
    },
  },
};
